import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import _ from 'lodash';
import { authUserError } from 'pages/AppLogin/action';
import { ADD_EMAIL, EDIT_EMAIL, LIST_EMAIL, TOGGLE_DRAWER, TOGGLE_DELETE_MODAL } from './constant';
import { listEmail as listEmailAction, listEmailSuccess, listEmailError, addEmailSuccess, addEmailError, editEmailSuccess, editEmailError, toggleDrawer, toggleDeleteModal } from './action';
import { addAddonEmail, editAddonEmail, listAddonEmail } from 'services/addon';

export function* listEmailSaga(action) {
  try {
    const res = yield call(listAddonEmail, action.payload);
    const smtpData = JSON.parse(res.text);
    // console.log(smtpData);
    yield put(
      listEmailSuccess({
        total: smtpData.emailhosting.total,
        attributes: smtpData.emailhosting.emailhosting.map((item) => ({
          ...item,
          key: item.id,
        })),
      }),
    );
  } catch (err) {
    if (_.isEqual(err.status, 401)) {
      yield put(listEmailError(err.response.text));
      yield put(authUserError({}));
    }
    if (_.isEqual(err.status, 422)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError[0].message);
      yield put(listEmailError(err.response.text));
    }
    if (_.isEqual(err.status, 500)) {
      message.error('Something went wrong');
    }
  }
}

export function* addEmailSaga(action) {
  try {
    const res = yield call(addAddonEmail, action.payload);
    const userData = JSON.parse(res.text);
    yield put(addEmailSuccess(userData.data));
    yield put(toggleDrawer());
    yield put(listEmailAction({ page: 1, limit: 10 }));
    message.success(userData.data.message);
  } catch (err) {
    if (_.isEqual(err.status, 401)) {
      yield put(addEmailError(err.response.text));
      yield put(authUserError({}));
    }
    if (_.isEqual(err.status, 400)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError.message);
      yield put(addEmailError());
    }
    if (_.isEqual(err.status, 422)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError[0].message);
      yield put(addEmailError(err.response.text));
    }
    if (_.isEqual(err.status, 500)) {
      message.error('Something went wrong');
    }
  }
}

export function* editEmailSaga(action) {
  try {
    const res = yield call(editAddonEmail, action.payload);
    const userData = JSON.parse(res.text);
    yield put(editEmailSuccess(userData.data));
    yield put(toggleDrawer());
    yield put(listEmailAction({ page: 1, limit: 10 }));
    message.success(userData.data.message);
  } catch (err) {
    if (_.isEqual(err.status, 401)) {
      yield put(editEmailError());
      yield put(authUserError({}));
    }
    if (_.isEqual(err.status, 422)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError[0].message);
      yield put(editEmailError());
    }
    if (_.isEqual(err.status, 409)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError.message);
      yield put(editEmailError());
    }
    if (_.isEqual(err.status, 500)) {
      message.error('Something went wrong');
    }
  }
}

export function* toggleDrawerSaga(action) {
  put(toggleDrawer());
}
export function* toggleDeleteModalSaga(action) {
  put(toggleDeleteModal());
}

export default function* EmailSaga() {
  yield takeLatest(LIST_EMAIL, listEmailSaga);
  yield takeEvery(ADD_EMAIL, addEmailSaga);
  yield takeEvery(EDIT_EMAIL, editEmailSaga);
  yield takeEvery(TOGGLE_DRAWER, toggleDrawerSaga);
  yield takeEvery(TOGGLE_DELETE_MODAL, toggleDeleteModalSaga);
}
